import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { httpinstance } from "../../axios/api";

// --- Async Thunk: Call ratesearch/all API ---
export const fetchRateSearch = createAsyncThunk(
  "newsearchform/fetchRateSearch",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await httpinstance.post("ratesearch/all", payload);
      return res?.data; // API Response Data
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const manualstatus = createAsyncThunk(
  "manualstatus",
  async (payload, { rejectWithValue }) => {
    // console.log(payload, "payload");
    try {
      const res = await httpinstance.patch(`/queries/${payload}/mark-manual`,);
      return res?.data; // API Response Data
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const initialState = {
  newsearchformdata: {},   // Persisted search form data
  rqueryid:"",
  bookingdata:"",
bookingid:"",
mannualsearchdata:{},
  weightMode: 1,
  loading: false,
  error: null,
};

const newsearchformslice = createSlice({
  name: "newsearchform",
  initialState,
  reducers: {
    // Optional: manually update stored search form data
    updateStoredSearch(state, action) {
        console.log(action.payload, "action.payload",state);
      state.newsearchformdata = {
        
        ...action?.payload?.nodeData,
      };
    },
    updatemanualsearch(state, action) {
      // console.log(action.payload, "action.payload",state);
      state.mannualsearchdata = action?.payload
    },
    updatequeryid(state, action) {
      // console.log(action.payload, "action.payload",state);
        state.rqueryid = action?.payload
    },
    updatebookingid(state, action) {
      // console.log(action.payload, "action.payload",state);
        state.bookingid = action?.payload
    },
    bookingdata(state, action) {
      // console.log(action.payload, "action.payload",state);
        state.bookingdata = action?.payload
    },
   

    updateWeightMode(state, action) {
      state.weightMode = action?.payload;
    },
    // Optional: clear stored data (if needed)
    clearStoredSearch(state) {
      state.newsearchformdata = {};
      state.rqueryid = "";
      state.mannualsearchdata="";
      state.weightMode = 1;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchRateSearch.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRateSearch.fulfilled, (state, action) => {
        state.loading = false;

        // Persist API payload response
        state.newsearchformdata = action.payload;
      })
      .addCase(fetchRateSearch.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      }).addCase(manualstatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(manualstatus.fulfilled, (state, action) => {
        // state.loading = false;
        // Persist API payload response
        // state.newsearchformdata = action.payload;
      })
      .addCase(manualstatus.rejected, (state, action) => {
        // state.loading = false;
        // state.error = action.payload;
      })

  },
});

export const { updateStoredSearch, clearStoredSearch ,updatequeryid , bookingdata, updatebookingid,updatemanualsearch, updateWeightMode } =
  newsearchformslice.actions;

export const selectWeightMode = (state) => state.newsearchform.weightMode;

export default newsearchformslice.reducer;
